// Conceptos con auto-rellenado de Tipo de Gasto 606, ITBIS Retenido y Tipo ISR
export const CONCEPTOS = [
  // 10 – ADQUISICIONES DE ACTIVOS
  { value: 'ADQUISICIÓN DE INMUEBLES', label: 'ADQUISICIÓN DE INMUEBLES', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'ADQUISICIÓN DE MOBILIARIOS Y EQ. DE OFICINA', label: 'ADQUISICIÓN DE MOBILIARIOS Y EQ. DE OFICINA', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'ADQUISICIÓN DE MAQUINARIAS Y EQUIPOS', label: 'ADQUISICIÓN DE MAQUINARIAS Y EQUIPOS', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'ADQUISICIÓN EQUIPOS DE CÓMPUTO Y SOFTWARE', label: 'ADQUISICIÓN EQUIPOS DE CÓMPUTO Y SOFTWARE', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'ADQUISICIÓN EQUIPOS DE TRANSPORTE LIVIANO', label: 'ADQUISICIÓN EQUIPOS DE TRANSPORTE LIVIANO', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'ADQUISICIÓN EQUIPOS DE TRANSPORTE PESADO', label: 'ADQUISICIÓN EQUIPOS DE TRANSPORTE PESADO', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'ADQUISICIÓN DE OTROS ACTIVOS CAT II', label: 'ADQUISICIÓN DE OTROS ACTIVOS CAT II', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'ADQUISICIÓN DE OTROS ACTIVOS CAT III', label: 'ADQUISICIÓN DE OTROS ACTIVOS CAT III', tipo_gasto_606: '10 – ADQUISICIONES DE ACTIVOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  
  // 03 – ARRENDAMIENTOS
  { value: 'ARRENDAMIENTO A PERSONAS FÍSICAS', label: 'ARRENDAMIENTO A PERSONAS FÍSICAS', tipo_gasto_606: '03 – ARRENDAMIENTOS', itbis_retenido_porcentaje: 100, tipo_retencion: '1', aplica_bienes: false },
  { value: 'ARRENDAMIENTO A PERSONAS JURÍDICAS', label: 'ARRENDAMIENTO A PERSONAS JURÍDICAS', tipo_gasto_606: '03 – ARRENDAMIENTOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  
  // 04 – GASTOS DE ACTIVOS FIJOS
  { value: 'COMBUSTIBLE Y LUBRICANTES', label: 'COMBUSTIBLE Y LUBRICANTES', tipo_gasto_606: '04 – GASTOS DE ACTIVOS FIJOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS PF', label: 'MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS PF', tipo_gasto_606: '04 – GASTOS DE ACTIVOS FIJOS', itbis_retenido_porcentaje: 100, tipo_retencion: '4', aplica_bienes: false },
  { value: 'MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS PJ', label: 'MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS PJ', tipo_gasto_606: '04 – GASTOS DE ACTIVOS FIJOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'MANTENIMIENTO Y REPARACIÓN DE OTROS ACTIVOS PF', label: 'MANTENIMIENTO Y REPARACIÓN DE OTROS ACTIVOS PF', tipo_gasto_606: '04 – GASTOS DE ACTIVOS FIJOS', itbis_retenido_porcentaje: 100, tipo_retencion: '4', aplica_bienes: false },
  { value: 'MANTENIMIENTO Y REPARACIÓN DE OTROS ACTIVOS PJ', label: 'MANTENIMIENTO Y REPARACIÓN DE OTROS ACTIVOS PJ', tipo_gasto_606: '04 – GASTOS DE ACTIVOS FIJOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  
  // 07 – GASTOS FINANCIEROS
  { value: 'CARGOS Y COMISIONES BANCARIAS', label: 'CARGOS Y COMISIONES BANCARIAS', tipo_gasto_606: '07 – GASTOS FINANCIEROS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'INTERESES POR PRÉSTAMOS CON PF', label: 'INTERESES POR PRÉSTAMOS CON PF', tipo_gasto_606: '07 – GASTOS FINANCIEROS', itbis_retenido_porcentaje: 0, tipo_retencion: '6', aplica_bienes: false },
  { value: 'INTERESES POR PRÉSTAMOS BANCARIOS', label: 'INTERESES POR PRÉSTAMOS BANCARIOS', tipo_gasto_606: '07 – GASTOS FINANCIEROS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'INTERESES POR PRÉSTAMOS CON FINANCIERAS', label: 'INTERESES POR PRÉSTAMOS CON FINANCIERAS', tipo_gasto_606: '07 – GASTOS FINANCIEROS', itbis_retenido_porcentaje: 0, tipo_retencion: '5', aplica_bienes: false },
  { value: 'RETENCIÓN IMPUESTO 0.15', label: 'RETENCIÓN IMPUESTO 0.15', tipo_gasto_606: '07 – GASTOS FINANCIEROS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  
  // 09 – COMPRAS Y GASTOS QUE FORMARÁN PARTE DEL COSTO DE VENTA (Bienes)
  { value: 'COMPRAS Y GASTOS QUE FORMAN PARTE DEL COSTO DE VENTA', label: 'COMPRAS Y GASTOS QUE FORMAN PARTE DEL COSTO DE VENTA', tipo_gasto_606: '09 – COMPRAS Y GASTOS QUE FORMARÁN PARTE DEL COSTO DE VENTA', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: true },
  { value: 'COMPRAS A PROVEEDORES INFORMALES', label: 'COMPRAS A PROVEEDORES INFORMALES', tipo_gasto_606: '09 – COMPRAS Y GASTOS QUE FORMARÁN PARTE DEL COSTO DE VENTA', itbis_retenido_porcentaje: 100, tipo_retencion: '', aplica_bienes: true },
  
  // 02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS
  { value: 'CUOTAS Y OTRAS CONTRIBUCIONES', label: 'CUOTAS Y OTRAS CONTRIBUCIONES', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', label: 'GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'HONORARIOS POR SERVICIOS PF', label: 'HONORARIOS POR SERVICIOS PF', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 100, tipo_retencion: '2', aplica_bienes: false },
  { value: 'HONORARIOS POR SERVICIOS MJ', label: 'HONORARIOS POR SERVICIOS MJ', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 30, tipo_retencion: '', aplica_bienes: false },
  { value: 'SEGURIDAD, TRANSPORTES Y OTROS SERVICIOS PF', label: 'SEGURIDAD, TRANSPORTES Y OTROS SERVICIOS PF', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 100, tipo_retencion: '2', aplica_bienes: false },
  { value: 'SEGURIDAD, TRANSPORTES Y OTROS SERVICIOS PJ', label: 'SEGURIDAD, TRANSPORTES Y OTROS SERVICIOS PJ', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 100, tipo_retencion: '', aplica_bienes: false },
  { value: 'SEGUROS DE PROPIEDAD', label: 'SEGUROS DE PROPIEDAD', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'SEGUROS DE VEHÍCULOS', label: 'SEGUROS DE VEHÍCULOS', tipo_gasto_606: '02 – GASTOS POR TRABAJOS, SUMINISTROS Y SERVICIOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  
  // 05 – GASTOS DE REPRESENTACIÓN
  { value: 'DONACIONES', label: 'DONACIONES', tipo_gasto_606: '05 – GASTOS DE REPRESENTACIÓN', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'GASTOS DE VIAJES', label: 'GASTOS DE VIAJES', tipo_gasto_606: '05 – GASTOS DE REPRESENTACIÓN', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'OTROS GASTOS DE REPRESENTACIÓN', label: 'OTROS GASTOS DE REPRESENTACIÓN', tipo_gasto_606: '05 – GASTOS DE REPRESENTACIÓN', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'PUBLICIDAD Y PROMOCIÓN PERSONA FÍSICA', label: 'PUBLICIDAD Y PROMOCIÓN PERSONA FÍSICA', tipo_gasto_606: '05 – GASTOS DE REPRESENTACIÓN', itbis_retenido_porcentaje: 100, tipo_retencion: '2', aplica_bienes: false },
  { value: 'PUBLICIDAD Y PROMOCIÓN PERSONA JURÍDICA', label: 'PUBLICIDAD Y PROMOCIÓN PERSONA JURÍDICA', tipo_gasto_606: '05 – GASTOS DE REPRESENTACIÓN', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'RELACIONES PÚBLICAS', label: 'RELACIONES PÚBLICAS', tipo_gasto_606: '05 – GASTOS DE REPRESENTACIÓN', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  
  // 01 – GASTOS DE PERSONAL
  { value: 'GASTOS DE PERSONAL', label: 'GASTOS DE PERSONAL', tipo_gasto_606: '01 – GASTOS DE PERSONAL', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  { value: 'SEGURO MÉDICO PRIVADO', label: 'SEGURO MÉDICO PRIVADO', tipo_gasto_606: '01 – GASTOS DE PERSONAL', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false },
  
  // 08 – GASTOS EXTRAORDINARIOS
  { value: 'OTROS GASTOS EXTRAORDINARIOS', label: 'OTROS GASTOS EXTRAORDINARIOS', tipo_gasto_606: '08 – GASTOS EXTRAORDINARIOS', itbis_retenido_porcentaje: 0, tipo_retencion: '', aplica_bienes: false }
];

// ITBIS calculation options
export const ITBIS_OPTIONS = [
  { value: 18, label: '18%', tasa: 0.18 },
  { value: 16, label: '16%', tasa: 0.16 },
  { value: 0, label: '0%', tasa: 0 },
  { value: 'exento', label: 'Exento', tasa: 0 }
];

// ITBIS Retenido options
export const ITBIS_RETENIDO_OPTIONS = [
  { value: 0, label: '0% (Sin retención)' },
  { value: 30, label: '30%' },
  { value: 100, label: '100%' }
];

// ISR Retenido options (solo para servicios, NO aplica para código 09)
export const ISR_RETENIDO_OPTIONS = [
  { value: 0, label: '0% (Sin retención)' },
  { value: 2, label: '2%' },
  { value: 10, label: '10%' }
];

// NCF Types for Dominican Republic
export const TIPOS_NCF = [
  { value: 'B01', label: 'B01 - Factura Crédito Fiscal' },
  { value: 'B02', label: 'B02 - Factura Consumidor Final' },
  { value: 'B03', label: 'B03 - Nota de Débito' },
  { value: 'B04', label: 'B04 - Nota de Crédito' },
  { value: 'B11', label: 'B11 - Proveedores Informales' },
  { value: 'B12', label: 'B12 - Registro Único de Ingresos' },
  { value: 'B13', label: 'B13 - Gastos Menores' },
  { value: 'B14', label: 'B14 - Régimen Especial' },
  { value: 'B15', label: 'B15 - Gubernamental' },
  { value: 'B16', label: 'B16 - Exportaciones' },
  { value: 'E31', label: 'E31 - Factura Crédito Fiscal Electrónica' },
  { value: 'E32', label: 'E32 - Factura Consumidor Final Electrónica' },
  { value: 'E33', label: 'E33 - Nota de Débito Electrónica' },
  { value: 'E34', label: 'E34 - Nota de Crédito Electrónica' },
  { value: 'E41', label: 'E41 - Compras Electrónicas' },
  { value: 'E43', label: 'E43 - Gastos Menores Electrónicos' },
  { value: 'E44', label: 'E44 - Régimen Especial Electrónico' },
  { value: 'E45', label: 'E45 - Gubernamental Electrónico' },
  { value: 'E46', label: 'E46 - Exportaciones Electrónicas' },
  { value: 'E47', label: 'E47 - Pagos al Exterior Electrónicos' }
];

// Month names in Spanish
export const MESES = [
  { value: 'Enero', label: 'Enero' },
  { value: 'Febrero', label: 'Febrero' },
  { value: 'Marzo', label: 'Marzo' },
  { value: 'Abril', label: 'Abril' },
  { value: 'Mayo', label: 'Mayo' },
  { value: 'Junio', label: 'Junio' },
  { value: 'Julio', label: 'Julio' },
  { value: 'Agosto', label: 'Agosto' },
  { value: 'Septiembre', label: 'Septiembre' },
  { value: 'Octubre', label: 'Octubre' },
  { value: 'Noviembre', label: 'Noviembre' },
  { value: 'Diciembre', label: 'Diciembre' }
];

// Tipo de Factura options
export const TIPOS_FACTURA = [
  { value: 'Bienes', label: 'Bienes' },
  { value: 'Servicios', label: 'Servicios' }
];

// Formas de Pago
export const FORMAS_PAGO = [
  { value: '', label: '(Seleccione...)' },
  { value: '01', label: '01 - EFECTIVO' },
  { value: '02', label: '02 - CHEQUES/TRANSFERENCIAS/DEPÓSITO' },
  { value: '03', label: '03 - TARJETA CRÉDITO/DÉBITO' },
  { value: '04', label: '04 - COMPRA A CREDITO' },
  { value: '05', label: '05 - PERMUTA' },
  { value: '06', label: '06 - NOTA DE CREDITO' },
  { value: '07', label: '07 - MIXTO' }
];

// Tipos de Retención ISR (código + descripción + porcentaje)
export const TIPOS_RETENCION = [
  { value: '', label: '(Sin retención)', porcentaje: 0 },
  { value: '1', label: '1 - ALQUILERES', porcentaje: 10 },
  { value: '2', label: '2 - HONORARIOS', porcentaje: 10 },
  { value: '3', label: '3 - OTRAS RENTAS', porcentaje: 2 },
  { value: '4', label: '4 - OTRAS RENTAS (R. PRESUNTAS)', porcentaje: 2 },
  { value: '5', label: '5 - INTERESES PAGADOS A PJ', porcentaje: 1 },
  { value: '6', label: '6 - INTERESES PAGADOS A PF', porcentaje: 10 }
];

/**
 * Calculate ITBIS facturado from monto (minus descuento) and percentage
 * @param {number} monto - Base amount (without discount applied)
 * @param {number} descuento - Discount amount
 * @param {number|string} itbisPorcentaje - ITBIS percentage (18, 16, 0, or 'exento')
 * @returns {number} - Calculated ITBIS amount
 */
export function calcularITBIS(monto, descuento, itbisPorcentaje) {
  const montoBase = (parseFloat(monto) || 0) - (parseFloat(descuento) || 0);
  if (montoBase <= 0) return 0;
  
  if (itbisPorcentaje === 'exento' || itbisPorcentaje === 0) {
    return 0;
  }
  
  const tasa = itbisPorcentaje / 100;
  return parseFloat((montoBase * tasa).toFixed(2));
}

/**
 * Calculate ITBIS retenido from ITBIS facturado and retention percentage
 * @param {number} itbisFacturado - ITBIS facturado amount
 * @param {number} porcentajeRetencion - Retention percentage (0, 30, or 100)
 * @returns {number} - Calculated ITBIS retenido amount
 */
export function calcularITBISRetenido(itbisFacturado, porcentajeRetencion) {
  if (!itbisFacturado || itbisFacturado === 0) return 0;
  
  if (!porcentajeRetencion || porcentajeRetencion === 0) {
    return 0;
  }
  
  const tasa = porcentajeRetencion / 100;
  return parseFloat((itbisFacturado * tasa).toFixed(2));
}

/**
 * Calculate ISR retenido from monto and retention percentage
 * Solo aplica para servicios (NO para código DGII 09 - Bienes)
 * @param {number} monto - Base amount
 * @param {number} porcentajeRetencion - Retention percentage (0, 2, or 10)
 * @param {string} tipoFactura - Tipo de factura (Bienes o Servicios)
 * @returns {number} - Calculated ISR retenido amount
 */
export function calcularISRRetenido(monto, porcentajeRetencion, tipoFactura) {
  // ISR NO aplica para bienes (código 09)
  if (tipoFactura === 'Bienes') return 0;
  
  if (!monto || monto === 0) return 0;
  
  if (!porcentajeRetencion || porcentajeRetencion === 0) {
    return 0;
  }
  
  const tasa = porcentajeRetencion / 100;
  return parseFloat((monto * tasa).toFixed(2));
}

/**
 * Calculate ISR retenido based on tipo de retención (replaces porcentaje-based calculation)
 * Solo aplica para servicios (NO para código DGII 09 - Bienes)
 * @param {number} monto - Base amount (without discount applied)
 * @param {number} descuento - Discount amount
 * @param {string} tipoRetencion - Tipo de retención code (1-6)
 * @param {string} tipoFactura - Tipo de factura (Bienes o Servicios)
 * @returns {number} - Calculated ISR retenido amount
 */
export function calcularISRPorTipo(monto, descuento, tipoRetencion, tipoFactura) {
  // ISR NO aplica para bienes (código 09)
  if (tipoFactura === 'Bienes') return 0;
  if (!tipoRetencion) return 0;
  
  const montoBase = (parseFloat(monto) || 0) - (parseFloat(descuento) || 0);
  if (montoBase <= 0) return 0;
  
  const tipo = TIPOS_RETENCION.find(t => t.value === tipoRetencion);
  if (!tipo) return 0;
  
  const tasa = tipo.porcentaje / 100;
  return parseFloat((montoBase * tasa).toFixed(2));
}

/**
 * Calculate Total Facturado (auto-calculated but editable)
 * @param {Object} detalle - Detail line object
 * @returns {number} - Calculated total facturado
 */
export function calcularTotalFacturado(detalle) {
  const monto = parseFloat(detalle.monto) || 0;
  const descuento = parseFloat(detalle.descuento) || 0;
  const itbisFacturado = parseFloat(detalle.itbis_facturado) || 0;
  const impuestoSelectivo = parseFloat(detalle.impuesto_selectivo) || 0;
  const otrosImpuestos = parseFloat(detalle.otros_impuestos) || 0;
  const propina = parseFloat(detalle.propina_legal) || 0;
  const otrosCargos = parseFloat(detalle.otros_cargos) || 0;
  
  return parseFloat(((monto - descuento) + itbisFacturado + impuestoSelectivo + otrosImpuestos + propina + otrosCargos).toFixed(2));
}

/**
 * Convert month name to number
 * @param {string} mesNombre - Month name (Enero, Febrero, etc.)
 * @returns {number} - Month number (1-12)
 */
export function convertirMesANumero(mesNombre) {
  const meses = {
    'Enero': 1,
    'Febrero': 2,
    'Marzo': 3,
    'Abril': 4,
    'Mayo': 5,
    'Junio': 6,
    'Julio': 7,
    'Agosto': 8,
    'Septiembre': 9,
    'Octubre': 10,
    'Noviembre': 11,
    'Diciembre': 12
  };
  return meses[mesNombre] || '';
}

/**
 * Get all related data from selected concepto
 * @param {string} conceptoValue - Selected concepto value
 * @returns {Object|null} - Object with tipo_gasto_606, itbis_retenido_porcentaje, tipo_retencion, tipo_factura
 */
export function obtenerDatosDeConcepto(conceptoValue) {
  if (!conceptoValue) return null;
  
  const concepto = CONCEPTOS.find(c => c.value === conceptoValue);
  if (!concepto) return null;
  
  return {
    tipo_gasto_606: concepto.tipo_gasto_606,
    itbis_retenido_porcentaje: concepto.itbis_retenido_porcentaje,
    tipo_retencion: concepto.tipo_retencion,
    tipo_factura: concepto.aplica_bienes ? 'Bienes' : 'Servicios'
  };
}

/**
 * Validate NCF format and structure
 * @param {string} ncf - NCF string
 * @returns {Object} - { isValid: boolean, error: string, tipo: string }
 */
export function validarFormatoNCF(ncf) {
  if (!ncf || ncf.trim() === '') {
    return { isValid: false, error: 'NCF es requerido', tipo: '' };
  }

  // Remove spaces and convert to uppercase
  const ncfLimpio = ncf.trim().toUpperCase();
  
  // Validate length: must be 11 characters (B types) or 13 characters (E types)
  if (ncfLimpio.length !== 11 && ncfLimpio.length !== 13) {
    return { 
      isValid: false, 
      error: `NCF debe tener 11 (tipo B) o 13 (tipo E) caracteres (tiene ${ncfLimpio.length})`, 
      tipo: '' 
    };
  }
  
  // Extract tipo (first 3 characters: 1 letter + 2 digits)
  const tipoNCF = ncfLimpio.substring(0, 3);
  
  // Validate tipo against known types
  const tiposValidos = TIPOS_NCF.map(t => t.value);
  if (!tiposValidos.includes(tipoNCF)) {
    return { 
      isValid: false, 
      error: `Tipo de NCF "${tipoNCF}" no es válido`, 
      tipo: tipoNCF 
    };
  }
  
  // Get the first letter to determine expected length
  const tipoLetra = ncfLimpio[0];
  const longitudEsperada = tipoLetra === 'B' ? 11 : tipoLetra === 'E' ? 13 : 0;
  
  if (longitudEsperada > 0 && ncfLimpio.length !== longitudEsperada) {
    return {
      isValid: false,
      error: `Tipo ${tipoLetra} debe tener ${longitudEsperada} caracteres (tiene ${ncfLimpio.length})`,
      tipo: tipoNCF
    };
  }
  
  // Validate format based on type
  let formatoNCF;
  if (tipoLetra === 'B') {
    // Tipo B: 1 letter + 10 digits (11 chars total)
    formatoNCF = /^[B]\d{10}$/;
  } else if (tipoLetra === 'E') {
    // Tipo E: 1 letter + 12 digits (13 chars total)
    formatoNCF = /^[E]\d{12}$/;
  } else {
    return {
      isValid: false,
      error: 'Tipo de NCF no reconocido',
      tipo: tipoNCF
    };
  }
  
  if (!formatoNCF.test(ncfLimpio)) {
    return { 
      isValid: false, 
      error: `Formato inválido. Tipo ${tipoLetra} debe ser: 1 letra + ${longitudEsperada - 1} dígitos`, 
      tipo: tipoNCF 
    };
  }
  
  return { isValid: true, error: '', tipo: tipoNCF };
}

/**
 * Auto-detect tipo NCF from NCF number
 * @param {string} ncf - NCF string (e.g., "E310000001", "B010000123")
 * @returns {string} - Detected NCF type (e.g., "E31", "B01")
 */
export function detectarTipoNCF(ncf) {
  const validacion = validarFormatoNCF(ncf);
  return validacion.tipo;
}

/**
 * Auto-fill NCF with zeros between first 3 chars and last digits
 * Converts short format like "B0113" to "B0100000013" (11 chars for B)
 * or "E3113" to "E310000000013" (13 chars for E)
 * Examples:
 *   - "B0113" → "B0100000013" (4 chars → 11 chars)
 *   - "E31666666" → "E3100666666" (9 chars → 13 chars)
 *   - "e31666666" → "E3100666666" (case insensitive)
 * @param {string} input - NCF input string
 * @returns {string} - Auto-filled NCF or original if not applicable
 */
export function autoRellenarNCF(input) {
  if (!input) return input;
  
  const cleaned = input.trim().toUpperCase();
  
  // Debe tener al menos 4 caracteres (tipo + al menos 1 dígito)
  if (cleaned.length < 4) {
    return cleaned;
  }
  
  // Detectar tipo (primera letra)
  const tipoLetra = cleaned[0];
  
  // Determinar longitud total esperada según el tipo
  let longitudEsperada;
  if (tipoLetra === 'B') {
    longitudEsperada = 11;
  } else if (tipoLetra === 'E') {
    longitudEsperada = 13;
  } else {
    return cleaned; // Tipo no reconocido
  }
  
  // Si ya tiene la longitud correcta, retornar sin cambios
  if (cleaned.length === longitudEsperada) {
    return cleaned;
  }
  
  // Si es más largo de lo esperado, retornar sin cambios (probablemente inválido)
  if (cleaned.length > longitudEsperada) {
    return cleaned;
  }
  
  // Formato corto: primeros 3 chars (tipo) + últimos dígitos
  // Rellenar con ceros entre el tipo y los últimos dígitos
  const primeraParte = cleaned.substring(0, 3); // B01, E31, etc
  const ultimaParte = cleaned.substring(3); // 13, 123, 666666, etc
  
  // Calcular cuántos ceros necesitamos
  const cerosNecesarios = longitudEsperada - 3 - ultimaParte.length;
  
  if (cerosNecesarios >= 0) {
    const ceros = '0'.repeat(cerosNecesarios);
    return primeraParte + ceros + ultimaParte;
  }
  
  return cleaned;
}

/**
 * Create empty detail line with default values
 * @param {string} periodo - Current period/month
 * @returns {Object} - Empty detail line object
 */
export function crearLineaVacia(periodo) {
  return {
    mes: convertirMesANumero(periodo) || '',
    dia: '',
    ncf: '',
    ncf_modificado: '',
    tipo_ncf: '',
    id_entidad_proveedor: null,
    rnc_proveedor: '',
    nombre_proveedor: '',
    descripcion: '',
    concepto: '', // Renombrado de gasto_anexo
    tipo_gasto_606: '', // Renombrado de codigo_dgii
    tipo_factura: 'Servicios', // Default a Servicios (más común)
    monto: '',  // Vacío para UX, se muestra placeholder
    descuento: '',  // Vacío para UX
    monto_facturado: '',  // Monto - Descuento (base antes de impuestos)
    itbis_porcentaje: 0, // Selector - mantiene 0
    itbis_facturado: '',  // Vacío para UX
    itbis_retenido_porcentaje: 0, // Selector - mantiene 0
    itbis_retenido: '',  // Vacío para UX
    itbis_proporcionalidad: '',  // ITBIS sujeto a proporcionalidad (Art. 349)
    itbis_costo: '',  // ITBIS llevado al costo
    isr_retenido: '',  // Monto Retención Renta
    tipo_retencion: '', // Tipo de retención ISR
    impuesto_selectivo: '',  // Vacío para UX
    otros_impuestos: '',  // Vacío para UX
    propina_legal: '',  // Vacío para UX
    otros_cargos: '',  // Vacío para UX
    total_facturado: '',  // Auto-calculado pero editable
    forma_pago: '',
    numero_cheque: '',
    fecha_cheque: '',
    banco: '',
    cuenta: ''
  };
}

/**
 * Export data to CSV format with UTF-8 BOM for Excel compatibility
 * @param {Object} formData - Form data with header and details
 */
export function exportarCSV(formData) {
  if (!formData.detalles || formData.detalles.length === 0) {
    alert('No hay datos para exportar');
    return;
  }

  // CSV Headers (nombres en MAYÚSCULAS, sin Año ni Periodo ya que van arriba)
  const headers = [
    '#',
    'MES',
    'DÍA',
    'NCF FACTURA',
    'NCF MODIFICADO',
    'TIPO DE NCF',
    'RNC',
    'SUPLIDOR',
    'DESCRIPCIÓN DEL BIEN O SERVICIO',
    'CONCEPTO',
    'TIPO DE GASTO 606',
    'MONTO BIENES',
    'MONTO SERVICIOS',
    'DESCUENTO',
    'MONTO FACTURADO',
    'ITBIS FACTURADO',
    'ITBIS RETENIDO',
    'ITBIS SUJETO A PROPORCIONALIDAD (ART. 349)',
    'ITBIS LLEVADO AL COSTO',
    'MONTO RETENCIÓN RENTA',
    'IMPUESTO SELECTIVO AL CONSUMO',
    'OTROS IMPUESTOS/TASAS',
    'MONTO PROPINA LEGAL',
    'OTROS CARGOS EN LA FACTURA',
    'TOTAL FACTURADO',
    'TIPO DE RETENCIÓN',
    'FORMA DE PAGO',
    'NÚMERO DE CHEQUE',
    'FECHA DE CHEQUE',
    'BANCO',
    'CUENTA',
    'TIPO FACTURA'
  ];

  // Convert concepto value to readable string
  const formatConcepto = (conceptoValue) => {
    if (!conceptoValue) return '';
    const concepto = CONCEPTOS.find(c => c.value === conceptoValue);
    return concepto ? concepto.label : conceptoValue;
  };

  // Convert tipo_retencion to full label
  const formatTipoRetencion = (tipoValue) => {
    if (!tipoValue) return '';
    const tipo = TIPOS_RETENCION.find(t => t.value === tipoValue);
    return tipo ? tipo.label : tipoValue;
  };

  // Convert forma_pago to full label
  const formatFormaPago = (formaPagoValue) => {
    if (!formaPagoValue) return '';
    const forma = FORMAS_PAGO.find(f => f.value === formaPagoValue);
    return forma ? forma.label : formaPagoValue;
  };

  // Build CSV rows (sin año ni periodo, esos van en el header)
  const rows = formData.detalles.map((detalle, index) => {
    const monto = detalle.monto || 0;
    const esBienes = detalle.tipo_factura === 'Bienes';
    return [
    index + 1,
    detalle.mes || '',
    detalle.dia || '',
    detalle.ncf || '',
    detalle.ncf_modificado || '',
    detalle.tipo_ncf || '',
    detalle.rnc_proveedor || '',
    detalle.nombre_proveedor || '',
    detalle.descripcion || '',
    formatConcepto(detalle.concepto),
    detalle.tipo_gasto_606 || '',
    esBienes ? monto : 0,
    esBienes ? 0 : monto,
    detalle.descuento || 0,
    detalle.monto_facturado || 0,
    detalle.itbis_facturado || 0,
    detalle.itbis_retenido || 0,
    detalle.itbis_proporcionalidad || 0,
    detalle.itbis_costo || 0,
    detalle.isr_retenido || 0,
    detalle.impuesto_selectivo || 0,
    detalle.otros_impuestos || 0,
    detalle.propina_legal || 0,
    detalle.otros_cargos || 0,
    detalle.total_facturado || 0,
    formatTipoRetencion(detalle.tipo_retencion),
    formatFormaPago(detalle.forma_pago),
    detalle.numero_cheque || '',
    detalle.fecha_cheque || '',
    detalle.banco || '',
    detalle.cuenta || '',
    detalle.tipo_factura || ''
  ];
  });

  // Escape CSV values (handle commas, quotes, newlines)
  const escapeCSV = (value) => {
    if (value === null || value === undefined) return '';
    const stringValue = String(value);
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  // Build CSV content with client info and año/periodo at the top
  // Año y Periodo van en columna D (posición 4), necesitamos 3 columnas vacías antes
  const csvContent = [
    `Cliente: ${escapeCSV(formData.nombre_cliente || '')},,,AÑO: ${escapeCSV(formData.año || '')}`,
    `RNC Cliente: ${escapeCSV(formData.rnc_cliente || '')},,,PERIODO: ${escapeCSV(formData.periodo || '')}`,
    '', // Empty line
    headers.map(escapeCSV).join(','),
    ...rows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');

  // Add UTF-8 BOM for Excel compatibility
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

  // Generate filename
  const clienteNombre = (formData.nombre_cliente || 'Sin_Cliente').replace(/[^a-zA-Z0-9]/g, '_');
  const periodo = String(formData.periodo || 'Sin_Periodo').replace(/[^a-zA-Z0-9]/g, '_');
  const año = formData.año || 'Sin_Año';
  const filename = `costos_gastos_${clienteNombre}_${periodo}_${año}.csv`;

  // Trigger download
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

/**
 * Export data to TXT format following DGII 606 specification (pipe-delimited)
 * Replicates the legacy VBA GenerarArchivo() behavior
 * @param {Object} formData - Form data with header and details
 */
export function exportarTXT606(formData) {
  if (!formData.detalles || formData.detalles.length === 0) {
    alert('No hay datos para exportar');
    return;
  }

  const rnc = (formData.rnc_cliente || '').trim();
  const mesNum = String(convertirMesANumero(formData.periodo) || 1).padStart(2, '0');
  const periodo = `${formData.año}${mesNum}`;
  const cantidadRegistros = formData.detalles.length;

  const header = `606|${rnc}|${periodo}|${cantidadRegistros}`;

  const formatNum = (val) => {
    const n = parseFloat(val) || 0;
    return n === 0 ? '' : n.toFixed(2);
  };

  const lineas = formData.detalles.map((det) => {
    const rncProv = (det.rnc_proveedor || '').trim();
    const tipoId = rncProv.length > 9 ? '2' : '1';

    const tipoGasto = (det.tipo_gasto_606 || '').trim();
    const tipoBienesServicios = tipoGasto.substring(0, 2);

    const mesDet = String(det.mes || mesNum).padStart(2, '0');
    const diaDet = String(det.dia || '01').padStart(2, '0');
    const fechaComprobante = `${formData.año}${mesDet}${diaDet}`;
    const fechaPago = fechaComprobante;

    const monto = parseFloat(det.monto) || 0;
    const montoFacturado = parseFloat(det.monto_facturado) || 0;
    const esBienes = det.tipo_factura === 'Bienes';
    const montoServicios = esBienes ? '' : formatNum(monto);
    const montoBienes = esBienes ? formatNum(monto) : '';

    const itbisFacturado = parseFloat(det.itbis_facturado) || 0;
    const itbisCosto = parseFloat(det.itbis_costo) || 0;
    const itbisProporcionalidad = parseFloat(det.itbis_proporcionalidad) || 0;
    const destinoItbis = (formData.destino_itbis || '').trim();

    let itbisAdelantar;
    if (destinoItbis === 'adelantar') {
      itbisAdelantar = itbisFacturado;
    } else if (destinoItbis === 'costo') {
      itbisAdelantar = itbisFacturado - itbisCosto;
    } else if (destinoItbis === 'proporcionalidad') {
      itbisAdelantar = itbisFacturado - itbisProporcionalidad;
    } else {
      itbisAdelantar = 0;
    }

    const tipoRet = (det.tipo_retencion || '').trim();
    const tipoRetencion2 = tipoRet.length > 0 ? tipoRet.padStart(2, '0').substring(0, 2) : '';

    const formaPago2 = (det.forma_pago || '').trim().substring(0, 2);

    const campos = [
      rncProv,
      tipoId,
      tipoBienesServicios,
      (det.ncf || '').trim(),
      (det.ncf_modificado || '').trim(),
      fechaComprobante,
      fechaPago,
      montoServicios,
      montoBienes,
      formatNum(montoFacturado),
      formatNum(det.itbis_facturado),
      formatNum(det.itbis_retenido),
      formatNum(det.itbis_proporcionalidad),
      formatNum(det.itbis_costo),
      formatNum(itbisAdelantar),
      '',
      tipoRetencion2,
      formatNum(det.isr_retenido),
      '',
      formatNum(det.impuesto_selectivo),
      formatNum(det.otros_impuestos),
      formatNum(det.propina_legal),
      formaPago2
    ];

    return campos.join('|');
  });

  let contenido = header + '\n';
  lineas.forEach((linea, i) => {
    if (i < lineas.length - 1) {
      contenido += linea + '\n';
    } else {
      contenido += linea;
    }
  });

  const blob = new Blob([contenido], { type: 'text/plain;charset=utf-8' });
  const filename = `DGII_F_606_${rnc}_${periodo}.TXT`;

  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

/**
 * Validate detail line
 * @param {Object} detalle - Detail line to validate
 * @returns {Object} - Validation result with isValid and errors
 */
export function validarLinea(detalle) {
  const errors = [];
  
  // Helper para validar string (maneja números y strings)
  const validarCampoTexto = (valor) => {
    if (valor === null || valor === undefined) return false;
    const valorStr = String(valor).trim();
    return valorStr.length > 0;
  };
  
  if (!validarCampoTexto(detalle.dia)) {
    errors.push('Día es requerido');
  }
  
  // Validar NCF con formato completo
  if (!validarCampoTexto(detalle.ncf)) {
    errors.push('NCF es requerido');
  } else {
    const ncfStr = String(detalle.ncf).trim();
    const validacionNCF = validarFormatoNCF(ncfStr);
    if (!validacionNCF.isValid) {
      errors.push(`NCF: ${validacionNCF.error}`);
    } else {
      // Validar que el tipo NCF detectado coincida con el tipo_ncf almacenado
      if (detalle.tipo_ncf && detalle.tipo_ncf !== validacionNCF.tipo) {
        errors.push(`Tipo de NCF no coincide: esperado "${validacionNCF.tipo}", encontrado "${detalle.tipo_ncf}"`);
      }
      
      // Validar NCF Modificado requerido para E34/B04 (Notas de Crédito)
      if ((validacionNCF.tipo === 'E34' || validacionNCF.tipo === 'B04') && 
          !validarCampoTexto(detalle.ncf_modificado)) {
        errors.push('NCF Modificado es requerido para Notas de Crédito (E34/B04)');
      }
    }
  }
  
  if (!validarCampoTexto(detalle.nombre_proveedor)) {
    errors.push('Nombre del suplidor es requerido');
  }
  
  if (!validarCampoTexto(detalle.concepto)) {
    errors.push('Concepto es requerido');
  }
  
  if (!validarCampoTexto(detalle.tipo_gasto_606)) {
    errors.push('Tipo de Gasto 606 es requerido');
  }
  
  if (!detalle.monto || detalle.monto <= 0) {
    errors.push('Monto debe ser mayor a 0');
  }
  
  // Validar ITBIS Facturado (manual)
  if (detalle.itbis_facturado === null || detalle.itbis_facturado === undefined) {
    errors.push('ITBIS Facturado es requerido');
  } else if (detalle.itbis_facturado < 0) {
    errors.push('ITBIS Facturado debe ser mayor o igual a 0');
  }
  
  if (!validarCampoTexto(detalle.forma_pago)) {
    errors.push('Forma de Pago es requerida');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

/**
 * Validate all detail lines before export
 * @param {Array} detalles - Array of detail lines
 * @returns {Object} - Validation result with isValid, errors by line
 */
export function validarTodas(detalles) {
  if (!detalles || detalles.length === 0) {
    return {
      isValid: false,
      mensaje: 'No hay líneas para exportar'
    };
  }
  
  const erroresPorLinea = [];
  
  detalles.forEach((detalle, index) => {
    const validacion = validarLinea(detalle);
    if (!validacion.isValid) {
      erroresPorLinea.push({
        linea: index + 1,
        errores: validacion.errors
      });
    }
  });
  
  if (erroresPorLinea.length > 0) {
    return {
      isValid: false,
      erroresPorLinea
    };
  }
  
  return {
    isValid: true
  };
}

/**
 * Validate for duplicate NCF per supplier (warning only, doesn't block export)
 * @param {Array} detalles - Array of detail lines
 * @returns {Object} - Validation result with tieneWarnings and warnings array
 */
export function validarNCFDuplicados(detalles) {
  if (!detalles || detalles.length === 0) {
    return {
      isValid: true,
      errores: []
    };
  }
  
  // Group by rnc_proveedor + ncf
  const ncfPorProveedor = {};
  
  detalles.forEach((detalle, index) => {
    const ncf = detalle.ncf ? detalle.ncf.trim().toUpperCase() : '';
    const rnc = detalle.rnc_proveedor ? detalle.rnc_proveedor.trim() : '';
    
    // Skip if NCF or RNC is empty
    if (!ncf || !rnc) return;
    
    const key = `${rnc}|${ncf}`;
    
    if (!ncfPorProveedor[key]) {
      ncfPorProveedor[key] = {
        lineas: [],
        ncf: ncf,
        proveedor: detalle.nombre_proveedor || 'Sin nombre',
        rnc: rnc
      };
    }
    
    ncfPorProveedor[key].lineas.push(index + 1);
  });
  
  // Find duplicates
  const duplicados = [];
  Object.values(ncfPorProveedor).forEach(grupo => {
    if (grupo.lineas.length > 1) {
      duplicados.push({
        lineas: grupo.lineas,
        mensaje: `NCF ${grupo.ncf} duplicado para ${grupo.proveedor} (RNC: ${grupo.rnc})`,
        ncf: grupo.ncf,
        proveedor: grupo.proveedor,
        rnc: grupo.rnc
      });
    }
  });
  
  return {
    isValid: duplicados.length === 0,
    errores: duplicados
  };
}

/**
 * Calculate totals from detail lines
 * @param {Array} detalles - Array of detail lines
 * @returns {Object} - Object with all relevant totals
 */
export function calcularTotales(detalles) {
  if (!detalles || detalles.length === 0) {
    return {
      totalMonto: 0,
      totalMontoBienes: 0,
      totalMontoServicios: 0,
      totalDescuento: 0,
      totalITBIS: 0,
      totalITBISRetenido: 0,
      totalISRRetenido: 0,
      totalImpuestoSelectivo: 0,
      totalOtrosImpuestos: 0,
      totalPropina: 0,
      totalOtrosCargos: 0,
      totalFacturado: 0
    };
  }
  
  const totalMonto = detalles.reduce((sum, det) => sum + (parseFloat(det.monto) || 0), 0);
  const totalMontoBienes = detalles.reduce((sum, det) => sum + (det.tipo_factura === 'Bienes' ? (parseFloat(det.monto) || 0) : 0), 0);
  const totalMontoServicios = detalles.reduce((sum, det) => sum + (det.tipo_factura !== 'Bienes' ? (parseFloat(det.monto) || 0) : 0), 0);
  const totalDescuento = detalles.reduce((sum, det) => sum + (parseFloat(det.descuento) || 0), 0);
  const totalITBIS = detalles.reduce((sum, det) => sum + (parseFloat(det.itbis_facturado) || 0), 0);
  const totalITBISRetenido = detalles.reduce((sum, det) => sum + (parseFloat(det.itbis_retenido) || 0), 0);
  const totalISRRetenido = detalles.reduce((sum, det) => sum + (parseFloat(det.isr_retenido) || 0), 0);
  const totalImpuestoSelectivo = detalles.reduce((sum, det) => sum + (parseFloat(det.impuesto_selectivo) || 0), 0);
  const totalOtrosImpuestos = detalles.reduce((sum, det) => sum + (parseFloat(det.otros_impuestos) || 0), 0);
  const totalPropina = detalles.reduce((sum, det) => sum + (parseFloat(det.propina_legal) || 0), 0);
  const totalOtrosCargos = detalles.reduce((sum, det) => sum + (parseFloat(det.otros_cargos) || 0), 0);
  const totalFacturado = detalles.reduce((sum, det) => sum + (parseFloat(det.total_facturado) || 0), 0);
  
  return {
    totalMonto: parseFloat(totalMonto.toFixed(2)),
    totalMontoBienes: parseFloat(totalMontoBienes.toFixed(2)),
    totalMontoServicios: parseFloat(totalMontoServicios.toFixed(2)),
    totalDescuento: parseFloat(totalDescuento.toFixed(2)),
    totalITBIS: parseFloat(totalITBIS.toFixed(2)),
    totalITBISRetenido: parseFloat(totalITBISRetenido.toFixed(2)),
    totalISRRetenido: parseFloat(totalISRRetenido.toFixed(2)),
    totalImpuestoSelectivo: parseFloat(totalImpuestoSelectivo.toFixed(2)),
    totalOtrosImpuestos: parseFloat(totalOtrosImpuestos.toFixed(2)),
    totalPropina: parseFloat(totalPropina.toFixed(2)),
    totalOtrosCargos: parseFloat(totalOtrosCargos.toFixed(2)),
    totalFacturado: parseFloat(totalFacturado.toFixed(2))
  };
}

const FuncionesProcesoCostosGastos = () => {
  return {
    CONCEPTOS,
    ITBIS_OPTIONS,
    ITBIS_RETENIDO_OPTIONS,
    TIPOS_NCF,
    MESES,
    TIPOS_FACTURA,
    FORMAS_PAGO,
    TIPOS_RETENCION,
    calcularITBIS,
    calcularITBISRetenido,
    calcularISRRetenido,
    calcularISRPorTipo,
    calcularTotalFacturado,
    convertirMesANumero,
    obtenerDatosDeConcepto,
    validarFormatoNCF,
    detectarTipoNCF,
    autoRellenarNCF,
    crearLineaVacia,
    exportarCSV,
    exportarTXT606,
    validarLinea,
    validarTodas,
    validarNCFDuplicados,
    calcularTotales
  };
};

export default FuncionesProcesoCostosGastos;
